import { ColumnDef } from "@tanstack/react-table";

export const getInitialColumnSizing = <TData, TValue>(
	columnDefs: ColumnDef<TData, TValue>[],
	locallyStoredValues?: Record<string, number>,
) => {
	const initialColumnSizing: Record<string, number> = {};

	columnDefs.forEach((columnDef) => {
		if (!columnDef.id) return;

		const resizable = columnDef.enableResizing === true;

		if (!resizable) {
			initialColumnSizing[columnDef.id] = columnDef.size !== undefined ? columnDef.size : 180;
		} else {
			const stored = locallyStoredValues?.[columnDef.id];
			if (stored !== undefined) {
				const columnMinsize = columnDef.minSize;
				const size = columnMinsize ? Math.max(stored, columnMinsize) : stored;
				initialColumnSizing[columnDef.id] = size;
			} else if (columnDef.size !== undefined) {
				initialColumnSizing[columnDef.id] = columnDef.size;
			} else {
				initialColumnSizing[columnDef.id] = 180;
			}
		}
	});

	return initialColumnSizing;
};
